<ol class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs">
    <span [routerLink]="breadcrumb.link">
      {{ breadcrumb.label }}
    </span>
    <i class="fas fa-angle-right"></i>
  </li>
</ol>
